import useAccessToken from './use-access-token';

var useLoggedIn = function useLoggedIn() {
  return !!useAccessToken();
};

export default useLoggedIn;